export interface Invite {
  id: string;
  tenantId: string;
  type: string;
  status: InviteStatus;
  createdAt: Date;
  expiredAt: Date;
}

export enum InviteStatus {
  New = 1,
  Pending = 2,
  Sent = 3,
  Refused = 4,
  Accepted = 5,
  FailedToSend = 6
}
